import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import style from "../../assets/style/HomePage/blog.module.scss";

function Blog({ HomeData }) {
  const blogData = HomeData?.blogs;
  const { t, i18n } = useTranslation();

  return (
    <>
      <div className= {  style.blogCardsSectionContainer}>
        <h3>Latest Blogs</h3>
        <div>
          <div className={`${style.blogMainContainer} container`}>
          <div className={`row`}>
            <div className={`${style.mainBlogCards} col-lg-6 col-md-12 `  }>
              <img src={blogData?.main?.image} alt="image" />
              <div className={i18n.language === 'en'? style.firstMainBlog : style.firstMainBlogAr}>
                <p>{blogData?.main?.title}</p>
                <Link to={`/Show-Blog/${blogData?.main?.id}`}>
                <div className={style.readMoreDiv}>
                  <p>Read More</p>
                </div>
                </Link>
              </div>
            </div>
            <div className={`${style.subMainBlogCards} col-lg-6 col-md-12 `}>
              {blogData?.random?.map((item, index) => (
                <div className={style.subBlogCards} key={index}>
                  <img src={item?.image} alt="image" />

                  {/* <div className={  style.subThreeBlog}> */}
                  <div className={ i18n.language === 'en' ? style.subThreeBlog : style.subThreeBlogAr }>
                    <div>
                      {/* <h5>{item?.title}</h5> */}
                      <p>{item?.title}</p>
                    </div>
                    <Link to={`/Show-Blog/${item?.id}`}>
                    <div className={style.readMoreDiv}>
                      <p>Read More</p>
                    </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      </div>

      <div className={style.blogCardsSectionContainerMobile}>
        <h3>Latest Blogs</h3>
        <div>
          <div className={style.blogMainContainer}>
            <div className={style.mainBlogCards}>
              <img src={blogData?.main?.image} alt="image" />
              <div className={style.firstMainBlog}>
                <p>{blogData?.main?.title}</p>
                <Link to={`/Show-Blog/${blogData?.main?.id}`}>
                <div className={style.readMoreDiv}>
                  <p>Read More</p>
                </div>
                  </Link>
              </div>
            </div>
            <div className={style.subMainBlogCards}>
              {blogData?.random?.slice(0,2).map((item, index) => (
                <div className={style.subBlogCards} key={index}>
                  <img src={item?.image} alt="image" />

                  <div className={style.subThreeBlog}>
                    <div>
                      {/* <h5>{item?.title}</h5> */}
                      <p>{item?.title}</p>
                    </div>
                     <Link to={`/Show-Blog/${item?.id}`}>
                    <div className={style.readMoreDiv}>
                      <p>Read More</p>
                    </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
  
    </>
  );
}

export default Blog;
